<script lang="ts">
  import { formatMoney } from '$lib/format';
  import { t } from '$lib/i18n/index.svelte';
  import type { PaymentRequestElement } from '$lib/protocol/types';

  let { element }: { element: PaymentRequestElement } = $props();
</script>

<!-- RESERVED in protocol v1: an informational card with NO way to pay, so the
     message does not vanish without trace, and the app does not pretend to
     support something it does not. -->
<div class="payment">
  <div class="head">
    <strong>{t('el.payment.title')}</strong>
    <span class="state">{element.state}</span>
  </div>
  <p class="amount">{formatMoney(element.money)}</p>
  <p class="info">{t('el.payment.info')}</p>
</div>

<style>
  .payment {
    min-width: 200px;
  }
  .head {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }
  .state {
    font-size: 12px;
    color: var(--ink-soft);
  }
  .amount {
    margin: 6px 0;
    font-size: 20px;
    font-weight: 700;
  }
  .info {
    margin: 0;
    font-size: 13px;
    color: var(--ink-soft);
  }
</style>
